$(window).on("resize", function() {
	if ($(this).width() > 1200) {
		if (window.device == 'mobile') {
			location.reload()
		}
		window.device = 'desktop';
	} else {
		if (window.device == 'desktop') {
			location.reload()
		}
		window.device = 'mobile';
	}


	if ($(this).width() > 1100 && $(this).width() < 1400 && isIpad()) {
		$("#landscape-lock").removeClass("hidden")
	} else {
		$("#landscape-lock").addClass("hidden")
	}
}).trigger("resize")


// 檢查裝置是否為 iPad
function isIpad() {
	return /iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchend' in document;
}







if (navigator.appVersion.indexOf("Mac") != -1) {
	$("body").get(0).style.setProperty('--lock', "15px");
} else {
	$("body").get(0).style.setProperty('--lock', "17px");
}












function lerp(start, end, amt) {
	return (1 - amt) * start + amt * end
}


class RyderMarquee {
	constructor(el, setting) {
		this.hero = $(el).parent().get(0)
		this.wrapper = el
		this.delta = 0
		this.transform = 0
		this.step = 1
		this.direct = 0
		this.vertical = false
		this.stopOnHover = false
		this.isHover = false
		this.isAcc = false
		this.acc = 0.5

		Object.assign(this, setting)


		if (device == 'mobile') {
			this.step /= 2
			this.acc /= 2
		}

		if (this.direct == 1) {
			if (!this.vertical) {
				// 橫式
				this.wrapper.style.transform = `translate3d(-${this.rectSize / 2}px, 0, 0)`;
			} else {
				// 直式
				this.wrapper.style.transform = `translate3d(0, -${this.rectSize / 2}px, 0)`;
			}

			this.transform = -this.rectSize / 2 || 0
		}

		if (this.stopOnHover) {
			$(el).hover(() => {
				this.isHover = true
			}, () => {
				this.isHover = false
			})
		}
	}

	animate() {
		this.rectSize = !this.vertical
			? this.wrapper.getBoundingClientRect().width
			: this.wrapper.getBoundingClientRect().height;

		this.delay = 50;

		if (this.velo != null) {
			this.delta = lerp(this.delta, this.scrollY - this.velo, 0.1);
		}

		if (this.delta < 0) {
			this.delta = 0;
		}

		this.velo = this.scrollY;

		clearTimeout(this.timer);

		this.timer = setTimeout(this.clear, this.delay);


		if (!this.isHover) {
			this.transform += this.step
		}

		if (this.direct == 1) {
			if (this.transform > 0) {
				this.transform = -this.rectSize / 2;
			}

			if (this.isAcc) {
				this.transform += 0.5 + (this.delta * this.acc);
			}

			if (!this.vertical) {
				this.wrapper.style.transform = `translate3d(${this.transform}px, 0, 0)`;
			} else {
				this.wrapper.style.transform = `translate3d(0, ${this.transform}px, 0)`;
			}
		} else {
			if (this.transform > this.rectSize / 2) {
				this.transform = 0;
			}

			if (this.isAcc) {
				this.transform += 0.5 + (this.delta * this.acc);
			}

			if (!this.vertical) {
				this.wrapper.style.transform = `translate3d(-${this.transform}px, 0, 0)`;
			} else {
				this.wrapper.style.transform = `translate3d(0, -${this.transform}px, 0)`;
			}
		}
	}

	render() {
		this.scrollY = $(window).scrollTop()

		const bounding = this.hero.getBoundingClientRect();
		const distance = (window.innerHeight + this.scrollY) - (bounding.top + this.scrollY);
		const percentage = distance / ((window.innerHeight + bounding.height) / 100);

		this.animate();
	}

	clear() {
		this.delta = 0;
		this.velo = null;
	}

	create() {
		gsap.ticker.add(this.render.bind(this));
	}
}



function marqueeHandler(el, options = {}) {
	const {
		direct = 0, //0是往左 1是往右
		step = null, //移動速度
		stopOnHover = false, //hover時停止
		isAcc = false, //是否滾動時加速
		acc = 0.5, //滾動時的加速度
		vertical = false, //直式
	} = options;

	let $copy = $(el).contents().clone();
	$(el).append($copy);

	let ryderOptions = {
		direct,
		stopOnHover,
		isAcc,
		acc,
		vertical,
	};

	if (step !== null) {
		ryderOptions.step = step;
	}

	let ryderMarquee = new RyderMarquee(el, ryderOptions).create();
}








function RyderCursor(el) {
	this.$el = el
	this.x = 0
	this.y = 0
	this.mouseX = 0
	this.mouseY = 0
	this.radians = 0
	this.easing = 1

	this.init = function() {


		gsap.ticker.add(this.update.bind(this));


		$(window).on("mousemove", (e) => {
			this.mouseX = e.clientX - this.$el.width() / 2
			this.mouseY = e.clientY - this.$el.height() / 2
		})

	}

	this.update = function() {

		var dx = this.mouseX - this.x
		this.x += dx * this.easing


		var dy = this.mouseY - this.y
		this.y += dy * this.easing



		var speedX = Math.abs(this.mouseX - this.x)
		var speedY = Math.abs(this.mouseY - this.y)
		var speed = Math.sqrt(speedX * speedX + speedY * speedY) * -1

		if (speed > -1) {
			speed = 0;
		}

		var scale = speed / 500 + 1;

		if (scale < 0.2) {
			scale = 0.2;
		}


		var angle = Math.atan2(this.mouseX - this.x, -(this.mouseY - this.y)) * (180 / Math.PI);

		// gsap.set(this.$el, {
		// 	rotation: angle,
		// })


		gsap.set(this.$el, {
			x: this.x,
			y: this.y,
			// scaleX: scale,
		})

	}
}


// new RyderCursor($("#ryder-cursor")).init();






$("#preload").delay(500).fadeOut(500)




// 首頁扣掉preload的時間
let _nowPage = location.href.split("#")[0].split("/").slice(-1)[0];

if (_nowPage != '') {
	gsap.delayedCall(.5, () => {
		$("#topmenuWrap").addClass("is-show")
	});
}








$("#backtotop").on("click", function() {
	gsap.to(window, {
		duration: 1.2,
		scrollTo: 0,
		ease: 'power2.inOut',
	});
})






function menuopen() {
	$("#mobile-topmenuWrap").addClass("is-show")
}

function menuclose() {
	$("#mobile-topmenuWrap").removeClass("is-show")
}






function goto(to) {
	menuclose()

	gsap.to(window, {
		duration: 1.2,
		scrollTo: {
			y: to,
			offsetY: $(window).height() * 0.2,
		},
		ease: 'power2.inOut',
	});
}






function mobileTopmenuHandler(el) {
	$(el).children().on("click", function() {
		$(this).toggleClass("is-open")
		$(".submenuList", this).slideToggle(300)
	})
}






// parallax
// 添加 ticker 來持續監控滾動
gsap.ticker.add(ryderParallax);

function ryderParallax() {
	// 當前滾動位置
	let scrollTop = $(window).scrollTop();
	let windowHeight = $(window).height();

	$("[data-parallax]").each(function(i, el) {
		// 元素的偏移位置
		let elementOffsetTop = $(el).offset().top;
		let elementHeight = $(el).outerHeight(true);

		// 計算元素進入和離開視窗的進度（0~1）
		let progress = (scrollTop + windowHeight - elementOffsetTop) / (windowHeight + elementHeight);

		// 計算要偏移的值
		let _r = (device != 'mobile') ? el.dataset.parallax : el.dataset.parallax * 0.6
		let _p = $(window).height() * _r

		// 確保進度在 0 到 1 之間
		progress = Math.max(0, Math.min(1, progress));

		// 根據進度計算位移，範圍是 -500 到 500
		let translateY = -_p + progress * _p * 2;

		// 應用位移效果
		gsap.set(el, {
			y: translateY
		});
	});
}









// // 選取所有 #footer-man img 的元素
// var images = $("#footer-man img");

// // 隨機選擇一個索引
// var randomIndex = Math.floor(Math.random() * images.length);

// // 從隨機選中的元素移除 hidden 類別
// images.eq(randomIndex).removeClass("hidden");




// footer card
if (device != 'mobile') {
	let $footercard_tl = gsap.timeline({
		paused: true
	})

	$footercard_tl.from("#footer-card", {
		duration: 1,
		y: -400,
	})


	ScrollTrigger.create({
		toggleActions: "play pause resume reverse", //重覆觸發
		trigger: "#footerWrap",
		start: "top 70%",
		end: "bottom 100%",
		// markers: true,
		scrub: 0.4,
		animation: $footercard_tl,
	});
}








// 選單下滑隱藏
var _scrollLast = 0

$(window).on("scroll", () => {
	var _scrollTop = $(window).scrollTop()
	var _allBottom = $("body").height() - $(window).height() - 100

	if (_scrollTop < 0 || _scrollTop > _allBottom) {
		return false;
	}

	if (_scrollTop > _scrollLast) {
		$("#topmenuWrap, #fixed-logo, #hamburger").addClass("is-hide")
	} else {
		$("#topmenuWrap, #fixed-logo, #hamburger").removeClass("is-hide")
	}

	_scrollLast = _scrollTop
})







function checkAnchor(id) {
	gsap.to(window, {
		duration: 1.2,
		scrollTo: {
			y: `#${id}`,
			// offsetY: $(window).height() * 0.2,
		},
		ease: 'power2.inOut',
		onComplete: function() {
			history.pushState("", document.title, window.location.pathname);
		}
	});
}








$(window).on("load", function() {
	// ryder特製anchor定位
	const _now = location.href.split("#")[0].split("/").slice(-1);
	let anchor = location.href.split("#")[1]

	if (anchor != undefined) {
		checkAnchor(anchor)
	}

	$("a").on("click", function(e) {
		let page = $(this).attr('href').split("#")[0].split("/").slice(-1);
		let anchor = $(this).attr('href').split("#")[1]

		if (_now[0] == page[0]) {
			// 同一頁不跳頁用滾的
			e.preventDefault()
			checkAnchor(anchor)
			menuclose()
		}
	})






	$(".cursor-target, a").hover(function() {
		$("#ryder-cursor").addClass("hover")
	}, function() {
		$("#ryder-cursor").removeClass("hover")
	})





	$("[data-enter]").each((i, el) => {
		let customOffset = $(el).data('enter') || 0.2;

		let ob_offset = $(window).height() * -customOffset;

		let observer = new IntersectionObserver(function(entries, observer) {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					entry.target.classList.add('is-enter');
				} else {
					if (!$(entry.target).hasClass('enter-once')) {
						entry.target.classList.remove('is-enter');
					}
				}
			});
		}, {
			root: null,
			rootMargin: `0px 0px ${ob_offset}px 0px`,
			threshold: 0
		});

		observer.observe(el);
	});





	// mobile inview
	if (device == 'mobile') {
		$("[data-view]").each((i, el) => {
			let customOffset = $(el).data('view') || 0.5;

			let ob_offset = $(window).height() * -customOffset;

			let observer = new IntersectionObserver(function(entries, observer) {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						entry.target.classList.add('in-view');
					} else {
						if (!$(entry.target).hasClass('inview-once')) {
							entry.target.classList.remove('in-view');
						}
					}
				});
			}, {
				root: null,
				rootMargin: `${ob_offset}px 0px ${ob_offset}px 0px`,
				threshold: 0
			});

			observer.observe(el);
		});
	}
})